import * as yup from 'yup';
import ValidationMessage from '../../constants/ValidationMessage';

const SignUpValidation: any = yup.object().shape({
    name: yup.string()
        .required(ValidationMessage.Field("your name"))
        .max(50, ValidationMessage.MaxLength('your name', 50))
        .matches(/^[a-zA-Z\s]+$/, ValidationMessage.OnlyAlphabets('name'))
        .trim(),

    email: yup.string().required(ValidationMessage.Field("your email"))
        .email(ValidationMessage.EMAIL_ADDRESS)
        .matches(ValidationMessage.EMAIL_REGREX, ValidationMessage.EMAIL_ADDRESS)
        .max(150, ValidationMessage.MaxLength('Email', 150))
        .trim(),

    password: yup.string().required(ValidationMessage.PASSWORD_REQUIRED)
        .min(8, ValidationMessage?.PASSWORD_MIN_CHAR)
        .max(15, ValidationMessage?.PASSWORD_MAX_CHAR)
        .matches(/^\S*$/, ValidationMessage?.NO_SPACE_ALLOWED)
        .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).*$/, ValidationMessage?.PASSWORD_UPPER_CASE),
    // .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[`~`!@#$%^&.,<>?/*:";'{}()=\[\]+_\-])[A-Za-z\d~`!@#$%^&.,<>?/*:";'{}()\[\]=+_\-]{8,15}$/, ValidationMessage?.PASSWORD_UPPER_CASE),
    // .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[`~`!@#$%^&.,<>?/*:";'{}()=\[\]+_\-])[A-Za-z\d~`!@#$%^&.,<>?/*:";'{}()\[\]=+_\-]{8,15}$/, ValidationMessage?.PASSWORD_MATCH),

    confirm_password: yup.string().required(ValidationMessage.CONFIRM_PASSWORD_REQUIRED)
        .min(8, ValidationMessage?.CONFIRM_PASSWORD_MIN_CHAR)
        .max(15, ValidationMessage?.CONFIRM_PASSWORD_MAX_CHAR)
        .oneOf([yup.ref('password')], ValidationMessage?.PASSWORD_CONFIRM_PASSWORD_MUST_MATCH),

    passcode: yup.string().required(ValidationMessage.PASSCODE_REQUIRED),

    agree_tnc: yup.boolean().required(ValidationMessage?.ANY_REQUIRED + "check.")
        .oneOf([true], "Please read and accept the Privacy Policy & End User License Agreement."),


});

export default SignUpValidation;

